import { AxiosResponse } from 'axios';

import { get } from 'services/api';

export const getAll = (): Promise<AxiosResponse> => get('getAllServices');
